/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useContext, useEffect, useState } from 'react'
import CardHeader from '../../../../../components/CardHeader'
import Toast from '../../../../../components/Toast'
import UpdateButton from '../../../../../components/UpdateButton'
import { useNavigate, useParams } from 'react-router-dom'
import CustomOverLay from '../../../../../components/CustomOverlay'
import Input from '../../../../../components/InputBox'
import TextArea from '../../../../../components/TextArea'
import RoundToTwoDecimalPlaces from '../../../../../CommonMethods/RoundToTwoDecimalPlaces'
import { dataService } from '../../../../../services/data.services'
import { GetBranchId } from '../../../../../CommonMethods/GetBranchId'
import GlobalContext from '../../../../../components/Context/GloablContext'

export default function AddInventoryList({type}) {
    const initialState = {
        item_name : "",
        uom: "",
        item_code : "",
        selling_price: "",
        opening_balance: false,
        quantity : "",
        item_price: "",
        value : "",
        description : ""
    }
    const mandatoryKeys = {
        item_name : "",
        uom: "",
        item_code : "",
        selling_price: "",
        
    }
    const openingBalanceKeys = {
        quantity : null,
        item_price: null,
        value : null,
    }
    const [state, setState] = useState(initialState)
    const [loading, setLoading] = useState(false);
    const [loadingPage, setLoadingPage] = useState(true);
    const navigate = useNavigate();
    const [submitSelected, setsubmitSelected] = useState(false);
    const [toastErrorMessage, setToastErrorMessage] = useState('')
    const [descriptionCount, setDescriptionCount] = useState(null)
    const {setToastmessage} = useContext(GlobalContext)
    const [isInventoryCode, setIsInventoryCode] = useState(false)
    let {id} = useParams();

    /**
     * The `handleInput` function is used to handle input changes in a form, perform calculations based
     * on the input values, and update the state accordingly.
     */
    const handleInput = (e) => {
        setIsInventoryCode(false)
        setToastErrorMessage('')
        setDescriptionCount(null)
        let { id, value } = e.target
    
        if (id === "selling_price" || id === "value" || id === "item_price" || id === "quantity") {
            value = value.replace(/[^0-9.]/g, '').replace(/(\.\d{2}).+$/, '$1')
            if (!(/^[0-9]*\.?[0-9]*$/.test(value))) {
                value = null
            }
        }
    
        if (id === "quantity" || id === "item_price" || id === "value") {
            if (value !== "") {
                if (id === "value" && value !== null && (state.quantity !== "" && state.quantity !== null)) {
                    setState((prv) => ({
                        ...prv,
                        ["item_price"]: (value === 0 || value === "0") ? 0 : (RoundToTwoDecimalPlaces(value / state.quantity) === Infinity || RoundToTwoDecimalPlaces(value / state.quantity) === NaN) ? 0 : RoundToTwoDecimalPlaces(value / state.quantity)
                    }))
                } else if (id === "quantity" && value !== null && (state.value !== "" && state.value !== null)) {
                    setState((prv) => ({
                        ...prv,
                        ["item_price"]: (value === 0 || value === "0") ? 0 : (RoundToTwoDecimalPlaces(state.value / value) === Infinity || RoundToTwoDecimalPlaces(state.value / value) === NaN) ? 0 : RoundToTwoDecimalPlaces(state.value / value)
                    }))
                } else if (id === "quantity" && value !== null && (state.item_price !== "" && state.item_price !== null)) {
                    setState((prv) => ({
                        ...prv,
                        ["value"]: (value === 0 || value === "0") ? 0 : (RoundToTwoDecimalPlaces(state.item_price * value) === Infinity || RoundToTwoDecimalPlaces(state.item_price * value) === NaN) ? 0 : RoundToTwoDecimalPlaces(state.item_price * value)
                    }))
                } else if (id === "item_price" && value !== null && (state.quantity !== "" && state.quantity !== null)) {
                    setState((prv) => ({
                        ...prv,
                        ["value"]: (value === 0 || value === "0") ? 0 : (RoundToTwoDecimalPlaces(state.quantity * value) === Infinity || RoundToTwoDecimalPlaces(state.quantity * value) === NaN) ? 0 : RoundToTwoDecimalPlaces(state.quantity * value)
                    }))
                }
            } else {
                setState((prv) => ({
                    ...prv,
                    ["item_price"]: "",
                    ["value"]: 0
                }))
            }
        }
    
        if (id === "description") {
            const words = value.trim().split(/\s+/);
            const currentWordCount = words?.length;
            setDescriptionCount(currentWordCount)
            if (currentWordCount <= 100) {
                setState((prv) => ({
                    ...prv,
                    [id]: value
                }))
            } else {
                setToastErrorMessage("Description cannot exceed 100 words")
            }
        } else {
            setState((prv) => ({
                ...prv,
                [id]: value
            }))
        }
    }
         
 
    /**
     * The function `handleCheckBox` is used to handle the state changes when a checkbox is checked or
     * unchecked.
     */
    const handleCheckBox = (e) => {
        setsubmitSelected(false)
        if(!e.target.checked) {
            setState((prv)=>({
                ...prv,
                quantity : "",
                item_price: "",
                value : "",
                opening_balance: false,
            }))
        } else {
            setState((prv)=>({
                ...prv,
                "opening_balance": true
            }))
        }
    }

    /**
     * The function `handleValidation` checks if certain keys in the `state` object are empty or null
     * and returns an array of error keys.
     * @returns The function `handleValidation` returns a boolean value. It returns `true` if there are
     * no errors in the `ErrorArray`, indicating that all mandatory keys have a non-empty value. It
     * returns `false` if there are any errors in the `ErrorArray`, indicating that one or more
     * mandatory keys have an empty value.
     */
    const handleValidation=()=>{  
        const ErrorArray=[]
        Object.keys(mandatoryKeys).map((key)=>{
            if(state[key]==='' ){
                ErrorArray.push(key)
            }
            if(state[key] === null) {
                ErrorArray.push(key)
            }
        })
        if(state.opening_balance) {
            Object.keys(openingBalanceKeys).map((key)=>{
                if(state[key]===''){
                    ErrorArray.push(key)
                }
                if(state[key] === null) {
                    ErrorArray.push(key)
                }
            }) 
        }
        return ErrorArray?.length===0
    }

    /**
     * The handleSubmit function is used to handle form submission in a React component, perform
     * validation, make an API call to add or update inventory data, and display success or error
     * messages.
     * @returns The function `handleSubmit` does not have a return statement, so it does not explicitly
     * return anything.
     */
    const handleSubmit = async(e) => {
        e.preventDefault()
        setLoading(true)
        setsubmitSelected(true);
        if(!handleValidation()){
            setToastErrorMessage("Please fill in all the mandatory fields") 
            setLoading(false)
            return
        }
        try {
            let endPoint = ""
            let body = state
            if(!state.opening_balance) {
                delete body.quantity
                delete body.value
                delete body.item_price
            } 
            body["item_code"] = state?.item_code.trim();
            let res = null
            if(type === "Add") {
                body["branch_id"] = await GetBranchId()
                endPoint = "inventory"
                res = await dataService.PostAPI(body,endPoint)
            } else {
                body = {
                    branch_id : await GetBranchId(),
                    description : state.description,
                    selling_price : state?.selling_price
                }
                endPoint = `inventory/${id}`
                res = await dataService.PatchAPI(body,endPoint)
            }
            setLoading(false)
            navigate(type === "Add" ? `/inventory-master/inventory-list` : `/inventory-master/inventory-list?${params}`)
            setToastmessage(type === "Edit" ? "Inventory item updated successfully" : res?.data?.data?.message)
        } catch (error){
            setLoading(false)
            if(error?.response?.data?.message === "Item Code already exists. Try another") {
                setIsInventoryCode(true)
            } 
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
        }

    }
    /**
     * The function `getViewRecords` retrieves data from an API endpoint and updates the state with the
     * received data.
     */
    const getViewRecords  = async() => {
        try {
            const res= await dataService.GetAPI(`inventory/${id}`);
            setState({
                item_name : res?.data?.data?.item_name || "",
                uom: res?.data?.data?.uom || "",
                item_code : res?.data?.data?.item_code || "",
                selling_price: res?.data?.data?.selling_price || "0",
                opening_balance: res?.data?.data?.opening_balance || "",
                quantity : res?.data?.data?.opening_balance ? parseInt(res?.data?.data?.quantity) : "",
                item_price: res?.data?.data?.opening_balance ? parseFloat(res?.data?.data?.item_price).toFixed(2) : "",
                value : res?.data?.data?.opening_balance ? parseFloat(res?.data?.data?.value).toFixed(2) : "",
                description : res?.data?.data?.description || ""
            })
            setLoadingPage(false);
        } catch (error) {
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
        }
    }
    const [params, setParams] = useState('')
    useEffect(() => {
        const queryString = window.location.search;
        const searchParams = new URLSearchParams(queryString);
        setParams(searchParams.toString())
        if(type === "Edit") {
            getViewRecords()
        }
    }, []) 
    return (
        <CardHeader noPadding>
            <div class="mainDataCntnrTop shadow-s13" style={{position: "sticky", position: "-webkit-sticky"}}>
                <h5 class="pageHeader addclass">{type} Inventory</h5>
                <div class="flex items-center">
                    <UpdateButton
                        ButtonName={"Cancel"}
                        loading={false}
                        handleOnCLick={() => navigate(type === "Add" ? `/inventory-master/inventory-list` : `/inventory-master/inventory-list?${params}`)}
                        classKey="cancl-btn"
                    />
                    <UpdateButton
                        loading={loading}
                        ButtonName={type !== "Add" ? "Update" : "Add"}
                        handleOnCLick={handleSubmit}
                        classKey={"actn-btn onboardInstitution"}
                    />
                </div>
                {toastErrorMessage!=='' &&<Toast
                    message={toastErrorMessage}
                    type="error"
                    setToastmessage={setToastErrorMessage} />}
            </div>
            {type === "Edit" && loadingPage && <CustomOverLay Active text="Loading..." classKey={`flex flex-col justify-center items-center sidebarOpenedOverlay`}/>}    
            {!(type === "Edit" && loadingPage) && <div className='mainDataCntnrPageDiv scrollBlue_thick'>
                <div className='w-[70%] mx-auto'>
                    <div className='border border-[#D0D5DD] p-3 rounded'>
                        <div className='flex -mx-10'>
                            <div className='w-[50%] px-10'>
                                <div className='flex'>
                                    <div className='flex items-center mb-4 w-full'>
                                        <label
                                            htmlFor='item_name'
                                            className='text-f7 font-normal text-[#031624] min-w-[120px] inline-flex'
                                        >
                                            Item Name
                                            <span class="req-fld-astrk">*</span>
                                        </label>
                                        <Input 
                                            type="text"
                                            state={state}
                                            id="item_name"
                                            maxLength={30}
                                            handleInput={handleInput}
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            text={"Enter item name"}
                                            placeholder="Enter Item Name"
                                            disable={type === "Edit"}
                                            isMandatoryField = {true} />
                                    </div>
                                </div>
                                <div className='flex'>
                                    <div className='flex items-center mb-4 w-full'>
                                        <label
                                            htmlFor='uom'
                                            className='text-f7 font-normal text-[#031624] min-w-[120px] inline-flex'
                                        >
                                            UoM
                                            <span class="req-fld-astrk">*</span>
                                        </label>
                                        <Input 
                                            type="text"
                                            state={state}
                                            id="uom"
                                            maxLength={30}
                                            handleInput={handleInput}
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            text={"Enter UoM"}
                                            placeholder={"Enter UoM"}
                                            disable={type === "Edit"}
                                            isMandatoryField = {true}
                                        />
                                    </div>
                                </div>
                                <div className='flex'>
                                    <div className='flex items-center mb-4 w-full'>
                                        <label
                                            htmlFor='item_code'
                                            className='text-f7 font-normal text-[#031624] min-w-[120px] inline-flex'
                                        >
                                            Item Code
                                            <span class="req-fld-astrk">*</span>
                                        </label>
                                        <Input 
                                            type="text"
                                            state={state}
                                            id="item_code"
                                            maxLength={30}
                                            handleInput={handleInput}
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            text={"Enter Item Code"}
                                            placeholder="Enter Item Code"
                                            disable={type === "Edit"}
                                            isMandatoryField = {true}
                                            showErrorBorder = {isInventoryCode}
                                        />
                                    </div>
                                </div>
                                <div className='flex'>
                                    <div className='flex items-center mb-4 w-full'>
                                        <label
                                            htmlFor='selling_price'
                                            className='text-f7 font-normal text-[#031624] min-w-[120px] inline-flex'
                                        >
                                            Selling Price
                                            <span class="req-fld-astrk">*</span>
                                        </label>
                                        <Input 
                                            type="text"
                                            state={state}
                                            id="selling_price"
                                            maxLength={10}
                                            handleInput={handleInput}
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            text={"Enter Selling Price"}
                                            placeholder="Enter Selling Price"
                                            isMandatoryField = {true}
                                        />
                                    </div>
                                </div>
                                <div class=" flex">
                                    <label for="Description" class="text-f7 mt-3 font-medium mb-1.5 min-w-[120px]">Description</label>
                                    <div className='h-[56px] w-full'>
                                        <TextArea
                                            type="text"
                                            state={state}
                                            id="description"
                                            handleInput={handleInput}
                                            maxLength={100}
                                            wordsLength={descriptionCount > 100}
                                            setsubmitSelected={setsubmitSelected}
                                            text="Address is mandatory"
                                            placeholder="Enter Description"
                                        />
                                    </div>
                                    {/* <textarea id="description" class="w-full border border-[#D0D5DD] rounded-lg py-2.5 px-3.5 outline-0 placeholder:text-f2 placeholder:text-[#818E98] placeholder:font-normal text-f2 font-normal text-[#031624] shadow-s7 h-[128px] resize-none" placeholder="Enter Description"></textarea> */}
                                </div>
                            </div>
                            <div className='w-[50%] px-10'>
                                <div className='flex'>
                                    <div className='flex items-center mb-4 w-full mt-2'>
                                        <div class="relative checkbox custom-checkBoxBlueBranch1 mb-1 flex">
                                            <input 
                                                onChange={(e) => handleCheckBox(e)}
                                                type="checkbox" 
                                                id="opening_balance" 
                                                disabled={type === "Edit"}
                                                checked={state.opening_balance}
                                            />
                                            <label for="opening_balance" className={`text-f7 font-normal text-[#031624] pl-2.5 w-full ${type !== "Edit" ? 'cursor-pointer' : ''}`}>Opening Balance</label>
                                        </div>
                                    </div>
                                </div>
                                <div className='flex'>
                                    <div className='flex items-center mb-4 w-full'>
                                        <label
                                            htmlFor='quantity'
                                            className='text-f7 font-normal text-[#031624] min-w-[100px] inline-flex'
                                        >
                                            Quantity
                                            {state.opening_balance && <span class="req-fld-astrk">*</span>}
                                        </label>
                                        <Input 
                                            type="number"
                                            state={state}
                                            id="quantity"
                                            maxLength={10}
                                            handleInput={handleInput}
                                            submitSelected={state.opening_balance && submitSelected && (state.quantity !== "" || state.quantity !== null)}
                                            setsubmitSelected={setsubmitSelected}
                                            text={"Enter Quantity"}
                                            placeholder="Quantity"
                                            disable={!state.opening_balance || type === "Edit"}
                                            isMandatoryField = {true}
                                        />
                                    </div>
                                </div>
                                <div className='flex'>
                                    <div className='flex items-center mb-4 w-full'>
                                        <label
                                            htmlFor='item_price'
                                            className='text-f7 font-normal text-[#031624] min-w-[100px] inline-flex'
                                        >
                                            Cost/Item
                                            {state.opening_balance && <span class="req-fld-astrk">*</span>}
                                        </label>
                                        <Input 
                                            type="text"
                                            state={state}
                                            id="item_price"
                                            maxLength={10}
                                            handleInput={handleInput}
                                            submitSelected={state.opening_balance && submitSelected && (state.item_price !== "" || state.item_price !== null)}
                                            setsubmitSelected={setsubmitSelected}
                                            text={"Enter Cost/Item"}
                                            placeholder="Cost/Item"
                                            disable={!state.opening_balance || type === "Edit"}
                                            isMandatoryField = {true}
                                        />                     
                                    </div>
                                </div>
                                <div className='flex'>
                                    <div className='flex items-center mb-4 w-full'>
                                        <label
                                            htmlFor='value'
                                            className='text-f7 font-normal text-[#031624] min-w-[100px] inline-flex'
                                        >
                                            Total Cost
                                            {state.opening_balance && <span class="req-fld-astrk">*</span>}
                                        </label>
                                        <Input 
                                            type="text"
                                            state={state}
                                            id="value"
                                            maxLength={10}
                                            handleInput={handleInput}
                                            submitSelected={state.opening_balance && submitSelected && (state.value !== "" || state.value !== null)}
                                            setsubmitSelected={setsubmitSelected}
                                            text={"Enter Total Cost"}
                                            placeholder="Total Cost"
                                            disable={!state.opening_balance || type === "Edit"}
                                            isMandatoryField = {true}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>}
        </CardHeader>
    )
}
